import { ROLES } from 'utils/Constants';

import {
  DisplayTextAmountColor,
  DisplayTextAmountColorAndCheckValidity,
} from '../TextAmountColor';

export const WordCountDisplay = ({
  userRole,
  textType,
  t,
  minWords,
  maxWords,
  actualTextWordCount,
  initialTextWordCount,
  // Writer-specific props
  formData,
  initialTextContent,
  setValidTextNbr,
}) => {
  return (
    <div className="box-detail-text">
      <div>
        {t('Nombre de mot à ajouter')} (Min/Max) :{minWords}/{maxWords}
      </div>
      <div>
        {t('Nombre total de mots ajoutés')} :
        {textType === 'NON_TRANSLATED' ? (
          userRole === ROLES.ADMIN ? (
            <DisplayTextAmountColor
              initialTextWordCount={initialTextWordCount}
              actualTextWordCount={actualTextWordCount}
              minWords={maxWords}
              maxWords={minWords}
            />
          ) : (
            <DisplayTextAmountColorAndCheckValidity
              formData={formData}
              initialText={initialTextContent}
              initialTextWordCount={initialTextWordCount}
              actualTextWordCount={actualTextWordCount}
              minWords={minWords}
              maxWords={maxWords}
              setValid={setValidTextNbr}
              textType={textType}
            />
          )
        ) : (
          <ColoredWordCount
            count={actualTextWordCount}
            userRole={userRole}
            min={minWords}
            max={maxWords}
          />
        )}
      </div>
    </div>
  );
};

const ColoredWordCount = ({ count, min, max, userRole }) => {
  if (userRole === ROLES.ADMIN) return <span>{count}</span>;

  return (
    <span
      style={{
        color: count > max ? '#FF8D4B' : count < min ? '#EE3900' : '#3c3c3c',
      }}
    >
      {count}
    </span>
  );
};
